module.exports = __webpack_public_path__ + "img/product_50.377ed83.webp";